export default __webpack_public_path__ + "static/media/Chrysler.ef8145ba.ico";